import { reduce } from "et3-type-guards";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render/index";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import getCorePopUpStore from "../../../stores/core/core-popup-store";
import { getSuperviseStore } from "../../../stores/supervisor-store/supervise-store/index";
import AdminEventsToSuperviseData from "./audited-events-to-supervise-data";
import SuperviseForm from "./supervise-form";

const Supervise = withLiteObserverAndTheme(() => {
  const location = useLocation();
  useEffect(() => {
    const search = reduce(() => location.search, "");
    getCoreHistoryStore().setPageName(
      "SUPERVISOR_SUPERVISE",
      "SUPERVISOR_SUPERVISE"
    );
    getSuperviseStore().checkURLSearch(search);
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("SUPERVISE")}
        subTitle={i18n.get("SUPERVISE_ADMIN_AUDITS")}
        withRefresh={false}
        withHelper={true}
        onPress={() => {
          getCorePopUpStore().showHelperMessage("Supervise_Helper_Text");
        }}
      />
      <SuperviseForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <AdminEventsToSuperviseData />
    </ET3PageDiv>
  );
});
export default Supervise;
